import { LanguageTypesEnum } from "./eums"

/**
 * Mapping from language code to display name
 * Based on LanguageTypesEnum but inverted for easy lookup by code
 */
export const LANGUAGE_NAMES: Record<string, string> = {
  [LanguageTypesEnum.USA_English]: "English",
  [LanguageTypesEnum.UK_English]: "English (UK)",
  [LanguageTypesEnum.Canadian_English]: "English (CA)",
  [LanguageTypesEnum.Swedish]: "Swedish",
  [LanguageTypesEnum.German]: "German",
  [LanguageTypesEnum.Norwegian]: "Norwegian",
  [LanguageTypesEnum.Finnish]: "Finnish",
  [LanguageTypesEnum.Spanish]: "Spanish",
  [LanguageTypesEnum.Portuguese]: "Portuguese",
  [LanguageTypesEnum.Turkish]: "Turkish",
  [LanguageTypesEnum.Polish]: "Polish",
  [LanguageTypesEnum.Hungarian]: "Hungarian",
  [LanguageTypesEnum.French]: "French",
  [LanguageTypesEnum.Russian]: "Russian",
  [LanguageTypesEnum.Philippines]: "Filipino",
  [LanguageTypesEnum.Japanese]: "Japanese",
  [LanguageTypesEnum.Vietnamese]: "Vietnamese",
  [LanguageTypesEnum.Danish]: "Danish",
  [LanguageTypesEnum.Croatian]: "Croatian"
}

/**
 * Get language display name by code
 * Falls back to uppercase code if not found
 */
export const getLanguageName = (code: string): string => {
  return LANGUAGE_NAMES[code.toLowerCase()] || code.toUpperCase()
}

/**
 * Get all available language codes from enum
 */
export const ALL_LANGUAGE_CODES = Object.values(LanguageTypesEnum)

/**
 * Default english locale
 */
export const DEFAULT_LOCALE = LanguageTypesEnum.USA_English
